import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AddOnsRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.add_on_master_create === true ||
    permissions.add_on_master_edit === true ||
    permissions.add_on_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default AddOnsRouteMiddleware;
